'use strict';

var _ = require('lodash');
var TransitionSearchCriteriaService = function TransitionSearchCriteriaService(SearchCriteria, constants, featureToggleService, currentStateCriteriaService, SearchCriteriaRuleFactory, MomentService, RsqlQuery, hepService) {
  var transitionData = require('../config/transitionData.json');
  var flightToMarketTemplate = transitionData['flight-analysis-grid-to-market-analysis'];
  var demandTransparencyToSeasonalityTemplate = transitionData['demand-transparency-to-seasonality'];
  var dashboardToMarketTemplate = transitionData['dashboard-market-chart-to-market-analysis'];
  var dashboardToFlightTemplate = transitionData['dashboard-market-chart-to-flight-analysis'];
  var dashboardMarketAlertsToMATemplate = transitionData['dashboard-alert-grid-to-market-analysis'];
  var dashboardFlightAlertsToFATemplate = transitionData['dashboard-flight-alert-grid-to-flight-analysis'];
  var dashboardFaresAlertsToFIMTemplate = transitionData['dashboard-fares-alert-grid-to-fares-analysis'];
  var scheduleChangeToMarketTemplate = transitionData['schedule-change-to-market-analysis'];
  var scheduleChangeToFlightTemplate = transitionData['schedule-change-to-flight-analysis'];
  var romSummarytoAnalysisConfig = transitionData['rom-summary-to-analysis'];
  var romSummarytoAnalysisNoPosConfig = transitionData['rom-summary-to-analysis-no-pos'];
  var drawerToRulesTemplate = transitionData['drawer-to-rules'];
  var pricingSummaryToAnalysisTemplate = transitionData['pricing-summary-to-analysis'];
  var whatIfFlightAnalysis = transitionData['what-if-to-flight-analysis'];
  var whatIfMarketAnalysis = transitionData['what-if-to-market-analysis'];
  function getDateOnly(d) {
    return d.startOf('day');
  }
  function mergeDates(array, d) {
    if (array.length > 0) {
      var lastRange = array[array.length - 1];
      var lastDayInRange = lastRange[1];
      if (d.subtract(1, 'day').isSame(lastDayInRange)) {
        lastRange[1] = d;
      } else {
        array.push([d, d]);
      }
    } else {
      array.push([d, d]);
    }
    return array;
  }
  function createDateCriteria(template) {
    return function (dateRange) {
      var d = _.cloneDeep(template);
      if (dateRange[0].isSame(dateRange[1])) {
        d.leftOperand = dateRange[0].toISOString();
        d.operator = '=';
      } else {
        d.leftOperand = dateRange[0].toISOString();
        d.rightOperand = dateRange[1].toISOString();
        d.operator = 'Between';
      }
      return d;
    };
  }
  function demandTransparencyToSeasonality(markets) {
    var marketDataTemplate = _.cloneDeep(demandTransparencyToSeasonalityTemplate[0]);
    marketDataTemplate.leftOperand = markets;
    var rules = [marketDataTemplate];
    return new SearchCriteria({
      context: constants.SEASONALITY,
      rules: rules
    });
  }
  function flightAnalysisGridToMarketAnalysis(rows, marketField, departureDateField) {
    // extract an array of all markets
    var markets = _(rows).map(marketField).uniq().sortBy().value();
    var marketDataTemplate = _.cloneDeep(flightToMarketTemplate[0]);
    marketDataTemplate.leftOperand = markets;

    // extract all dates and return an array of SearchCriteria for each of them
    var rules = _(rows).map(departureDateField).map(getDateOnly).uniqBy(function (date) {
      return date.valueOf();
    }).sortBy().value();
    rules = _.reduce(rules, mergeDates, []);
    rules = _.map(rules, createDateCriteria(flightToMarketTemplate[1]));
    if (rules.length > 0) {
      rules[0].isReadOnly = true;
    }

    // add markets SearchCriteriaRule at the beginning
    rules.unshift(marketDataTemplate);
    return new SearchCriteria({
      context: constants.MARKET_ANALYSIS,
      rules: rules
    });
  }
  function scheduleChangeToMarketAnalysis(selectedMarkets) {
    var rules = _.cloneDeep(scheduleChangeToMarketTemplate);
    rules[0].leftOperand = _.map(selectedMarkets, 'market');
    return new SearchCriteria({
      context: constants.MARKET_ANALYSIS,
      rules: rules
    });
  }
  function scheduleChangeToFlightAnalysis(legs) {
    var rules = _.cloneDeep(scheduleChangeToFlightTemplate);
    rules[0].leftOperand = _.map(legs, 'leg');
    return new SearchCriteria({
      context: constants.FLIGHT_ANALYSIS,
      rules: rules
    });
  }
  function dashboardToMARules(datesRanges, selectedMarkets, selectedPoses) {
    var rules = [createMarketCriteria(selectedMarkets)];
    if (selectedPoses && featureToggleService.isEnabled('SPOS')) {
      rules.push(createPosCriteria(selectedPoses));
    }
    rules = rules.concat(_.map(datesRanges, createDateCriteria(flightToMarketTemplate[1])));
    return rules;
  }
  function dashboardMarketPerformanceChartToMA(datesRanges, selectedMarkets, selectedPoses) {
    var rules = dashboardToMARules(datesRanges, selectedMarkets, selectedPoses);
    return new SearchCriteria({
      context: constants.MARKET_ANALYSIS,
      rules: rules
    });
  }
  function dashboardMarketPerformanceChartToFA(datesRanges, selectedLegs) {
    var rules = _.map(datesRanges, createDateCriteria(dashboardToFlightTemplate[1]));
    rules.unshift(createLeftOperandCriteria(dashboardToFlightTemplate[0], selectedLegs));
    return new SearchCriteria({
      context: constants.FLIGHT_ANALYSIS,
      rules: rules
    });
  }
  function dashboardMarketAlertsGridToMA(datesRanges, selectedMarketsSearchCriteria, selectedPosSearchCriteria, alertsTechnicalIds) {
    var rules = dashboardToMARules(datesRanges, selectedMarketsSearchCriteria, selectedPosSearchCriteria);
    rules.push(createMarketAlertsIdsCriteria(alertsTechnicalIds));
    return new SearchCriteria({
      context: constants.MARKET_ANALYSIS,
      rules: rules
    });
  }
  function dashboardFlightAlertsGridToFA(datesRanges, selectedLegs, alertsTechnicalIds) {
    var rules = _.map(datesRanges, createDateCriteria(dashboardFlightAlertsToFATemplate[2]));
    rules.unshift(createFlightAlertsIdsCriteria(alertsTechnicalIds));
    rules.unshift(createAlertsLegsCriteria(selectedLegs));
    return new SearchCriteria({
      context: constants.FLIGHT_ANALYSIS,
      rules: rules
    });
  }
  function dashboardFaresAlertsGridToFIM(datesRanges, selectedMarkets) {
    var rules = _.map(datesRanges, createDateCriteria(dashboardFaresAlertsToFIMTemplate[1]));
    dashboardFaresAlertsToFIMTemplate[0].leftOperand = selectedMarkets;
    rules.unshift(dashboardFaresAlertsToFIMTemplate[0]);
    return new SearchCriteria({
      context: constants.FARES,
      rules: rules
    });
  }
  function whatIfFlightToFA(datesRanges, selectedFlights, selectedLegs) {
    var rules = [createLeftOperandCriteria(whatIfFlightAnalysis[0], selectedFlights)];
    if (selectedLegs) {
      rules.push(createLeftOperandCriteria(whatIfFlightAnalysis[1], selectedLegs));
    }
    for (var index in datesRanges) {
      var rule = _.cloneDeep(whatIfFlightAnalysis[2]);
      rule.leftOperand = datesRanges[index].toISOString();
      rules.push(rule);
    }
    return new SearchCriteria({
      context: constants.FLIGHT_ANALYSIS,
      rules: rules
    });
  }
  function whatIfMarketToMA(datesRanges, selectedMarkets, selectedPoses) {
    var rules = [createLeftOperandCriteria(whatIfMarketAnalysis[0], selectedMarkets)];
    if (selectedPoses && selectedPoses.length > 0 && featureToggleService.isEnabled('SPOS')) {
      rules.push(createLeftOperandCriteria(whatIfMarketAnalysis[1], selectedPoses));
    }
    for (var index in datesRanges) {
      var rule = _.cloneDeep(whatIfMarketAnalysis[2]);
      rule.leftOperand = datesRanges[index].toISOString();
      rules.push(rule);
    }
    return new SearchCriteria({
      context: constants.MARKET_ANALYSIS,
      rules: rules
    });
  }
  function whatIfServiceToMAExact(selectedWhatIfRows) {
    return createRsqlOverrideWrapper('market', prepareRsqlQueryForMarket(_.chain(selectedWhatIfRows).map(function (row) {
      var picked = _.pick(row, ['routeId', 'pos', 'departureDate']);
      picked.market = extractMarketFromRouteId(picked.routeId);
      picked.departureDate = extractDateFromDateTime(picked.departureDate);
      return picked;
    }).value()));
  }
  function whatIfMarketToMAExact(selectedWhatIfRows) {
    return createRsqlOverrideWrapper(['market'], prepareRsqlQueryForMarket(_.chain(selectedWhatIfRows).map(function (row) {
      var picked = _.pick(row, ['market', 'pos', 'departureDate']);
      picked.departureDate = extractDateFromDateTime(picked.departureDate);
      return picked;
    }).value()));
  }
  function whatIfFlightToFAExact(selectedWhatIfRows) {
    return createRsqlOverrideWrapper(['cabin'], prepareRsqlQueryForFlightAnalysis(_.chain(selectedWhatIfRows).map(function (row) {
      var picked = _.pick(row, ['flightNumber', 'leg', 'departureDate']);
      picked.departureDate = extractDateFromDateTime(picked.departureDate);
      return picked;
    }).value()));
  }
  var createRsqlOverrideWrapper = function createRsqlOverrideWrapper(targetMode, rsql) {
    function isRsqlOverrideApplicable(mode) {
      return _.includes(targetMode, mode);
    }
    return {
      getRsqlOverride: function getRsqlOverride(mode) {
        return isRsqlOverrideApplicable(mode) ? rsql : undefined;
      }
    };
  };
  function extractMarketFromRouteId(routeId) {
    var markets = _.chain(routeId.split(',')).map(function (leg) {
      return _.last(_.trim(leg).split(' '));
    }).value();
    var origin = _.first(_.first(markets).split('-'));
    var destination = _.last(_.last(markets).split('-'));
    return origin + '-' + destination;
  }
  function extractDateFromDateTime(dateTime) {
    return dateTime.format(MomentService.TYPE.LOCAL_DATE.format);
  }
  function prepareRsqlQueryForFlightAnalysis(whatIfSearchCriteria) {
    var resultBuilder = new RsqlQuery().is('scenarioName').equalTo('PUBLISHED').and().startGroup();
    whatIfSearchCriteria.forEach(function (criteria, i, criterias) {
      var innerBuilder = new RsqlQuery();
      resultBuilder = resultBuilder.andGroup(innerBuilder.is('number').equalTo(criteria.flightNumber.toString()), innerBuilder.is('legs.market').equalTo(criteria.leg), innerBuilder.is('numberDepartureDate').equalTo(criteria.departureDate));
      if (i < criterias.length - 1) {
        resultBuilder = resultBuilder.or();
      }
    });
    return resultBuilder.endGroup().query();
  }
  function prepareRsqlQueryForMarket(whatIfSearchCriteria) {
    var resultBuilder = new RsqlQuery().is('scenarioName').equalTo('PUBLISHED').and().startGroup();
    whatIfSearchCriteria.forEach(function (criteria, i, criterias) {
      resultBuilder = resultBuilder.startGroup();
      if (!_.isNil(criteria.pos)) {
        resultBuilder = resultBuilder.is('pointOfSales.posName').equalTo(criteria.pos).and();
      }
      resultBuilder = resultBuilder.is('market').equalTo(criteria.market).and().is('departureDate').equalTo(criteria.departureDate).endGroup();
      if (i < criterias.length - 1) {
        resultBuilder = resultBuilder.or();
      }
    });
    return resultBuilder.endGroup().query();
  }
  function drawerToRules(userIds) {
    return new SearchCriteria({
      context: constants.RULES,
      rules: [createLeftOperandCriteria(drawerToRulesTemplate[0], userIds)]
    });
  }
  function romSummaryToAnalysis(selectedElement) {
    var result = currentStateCriteriaService.getSearchCriteria();
    result.context = constants.ROM_ANALYSIS;
    _.forEach(featureToggleService.isEnabled('SPOS') ? romSummarytoAnalysisConfig : romSummarytoAnalysisNoPosConfig, function (rule) {
      var currentRule = _.find(result.rules, {
        criterion: rule.criterion
      });
      if (!currentRule) {
        currentRule = new SearchCriteriaRuleFactory(rule);
        result.rules.push(currentRule);
      }
      currentRule.leftOperand = [selectedElement[rule.field]];
    });
    return result;
  }
  function pricingSummaryToAnalysis(selectedElement) {
    var rules = _.cloneDeep(pricingSummaryToAnalysisTemplate);
    rules[0].leftOperand = [selectedElement.market];
    rules[1].leftOperand = selectedElement.beginDate;
    rules[1].rightOperand = selectedElement.endDate;
    rules[2].leftOperand = [selectedElement.pos];
    rules[4].leftOperand = selectedElement.beginDate.startOf('day');
    rules[4].rightOperand = selectedElement.beginDate.endOf('day');
    rules[5].leftOperand = MomentService.now(MomentService.FIELD.EFFECTIVE_TIME_STAMP);
    if (!_.isEmpty(selectedElement.runNumber)) {
      rules[6].leftOperand = {
        value: parseInt(selectedElement.runNumber.slice(8)),
        dropdownVisibleValue: selectedElement.runNumber.slice(8)
      };
      var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
      rules[6].isHidden = runFrequency <= 1;
    }
    return new SearchCriteria({
      context: constants.PRICING_ANALYSIS,
      rules: rules
    });
  }
  function createMarketAlertsIdsCriteria(alertsTechnicalIds) {
    return createLeftOperandCriteria(dashboardMarketAlertsToMATemplate[0], alertsTechnicalIds);
  }
  function createFlightAlertsIdsCriteria(alertsTechnicalIds) {
    return createLeftOperandCriteria(dashboardFlightAlertsToFATemplate[0], alertsTechnicalIds);
  }
  function createAlertsLegsCriteria(selectedLegs) {
    return createLeftOperandCriteria(dashboardFlightAlertsToFATemplate[1], selectedLegs);
  }
  function createMarketCriteria(criteriaData) {
    return createLeftOperandCriteria(dashboardToMarketTemplate[0], criteriaData);
  }
  function createPosCriteria(criteriaData) {
    return createLeftOperandCriteria(dashboardToMarketTemplate[1], criteriaData);
  }
  function createLeftOperandCriteria(template, leftOperandValues) {
    var d = _.cloneDeep(template);
    d.leftOperand = leftOperandValues;
    return d;
  }
  return {
    flightAnalysisGridToMarketAnalysis: flightAnalysisGridToMarketAnalysis,
    demandTransparencyToSeasonality: demandTransparencyToSeasonality,
    scheduleChangeToMarketAnalysis: scheduleChangeToMarketAnalysis,
    scheduleChangeToFlightAnalysis: scheduleChangeToFlightAnalysis,
    dashboardMarketPerformanceChartToMA: dashboardMarketPerformanceChartToMA,
    dashboardMarketPerformanceChartToFA: dashboardMarketPerformanceChartToFA,
    dashboardMarketAlertsGridToMA: dashboardMarketAlertsGridToMA,
    dashboardFlightAlertsGridToFA: dashboardFlightAlertsGridToFA,
    dashboardFaresAlertsGridToFIM: dashboardFaresAlertsGridToFIM,
    romSummaryToAnalysis: romSummaryToAnalysis,
    drawerToRules: drawerToRules,
    pricingSummaryToAnalysis: pricingSummaryToAnalysis,
    whatIfFlightToFA: whatIfFlightToFA,
    whatIfMarketToMA: whatIfMarketToMA,
    whatIfMarketToMAExact: whatIfMarketToMAExact,
    whatIfFlightToFAExact: whatIfFlightToFAExact,
    whatIfServiceToMAExact: whatIfServiceToMAExact,
    extractMarketFromRouteId: extractMarketFromRouteId
  };
};
TransitionSearchCriteriaService.$inject = ['SearchCriteriaFactory', 'SearchCriteriaConstantsService', 'FeatureToggleService', 'CurrentStateCriteriaService', 'SearchCriteriaRuleFactory', 'MomentService', 'RsqlQueryFactory', 'HepService'];
module.exports = TransitionSearchCriteriaService;